import React, { useEffect, useState } from "react";
import Chart from "../common/Chart";
import SensorStyle from './SensorStyle.module.css';
import GridTable from "../common/GridTable";
import moment from "moment";
import { responseMsg } from "../common/ResponseMsg";
import { gridBadgeRender, getStatusGroupColor, getStatusGroupColorNew } from "../common/Common";
import Flex from "../../shared/components/Flex";
import useDevice from "../../shared/hooks/useDevice";
import Card from "../../shared/components/Card";
import Padding from "../../shared/components/Padding";
import Text from "../../shared/components/Text";
import Spacer from "../../shared/components/Spacer";
import { AgGridReact } from "ag-grid-react";
import ImgFolder from "../../assets/img/img_folder.png";

function DataChartNew(props) {
    const [ chartMeasurement, setChartMeasurement ] = useState([]);
    const [ minDate, setMinDate ] = useState(0);
    const [ maxDate, setMaxDate ] = useState(0);
    const [ ticks, setTicks ] = useState();
    const [ chart1, setChart1 ] = useState("line");
    const [ chart2, setChart2 ] = useState("line");
    const [ chart3, setChart3 ] = useState("line");
    const getStatusGroupColor = (data) =>{
        return data ? getStatusGroupColorNew(data).color : "rgba(62, 99, 237, 1)";
    }
    const device = useDevice();
    const isMobile = device !== "desktop";

    useEffect(() => {
        const tmp = {...props.searchProps, startDate:moment(props.searchProps.startDate).format("YYYY.MM.DD HH:mm:ss")}

        if (props.searchProps.interval) {
            fetch(`/api/system/sensors/chartNew/${props.selectedSensor.imei}/${tmp.startDate}/${tmp.endDate}?range=${props.searchProps.range}`, {
                method: "GET"
            })
            .then((res) => res.json())
            .then((json) => {
                if(json.code === responseMsg.SUCCESS.code) {
                    const ufcParseData = json.data.map(ele => {
                        return {...ele,create_dtm:moment.utc(ele.create_dtm).valueOf()};
                    })

                    setChartMeasurement(ufcParseData);

                    const ticks = [];

                    let min = json.data[json.data.length-1]?.create_dtm;
                    let max = json.data[0]?.create_dtm;

                    // ticks.push(moment.utc(min).valueOf());
                    const minTick = moment(json.data[json.data.length-1]?.create_dtm).add(-1, 'hours').format("YYYY-MM-DDTHH:00:00");
                    const maxTick = moment(json.data[0]?.create_dtm).add(1, 'hours').format("YYYY-MM-DDTHH:00:00");

                    ticks.push(moment.utc(minTick).valueOf());
                    ticks.push(moment.utc(min).valueOf());

                    while(true) {
                        min = moment(min).add(1, 'hours').format("YYYY-MM-DDTHH:00:00");

                        if (moment.utc(min).valueOf() >= moment.utc(max).valueOf()) {
                            break;
                        } else {
                            ticks.push(moment.utc(min).valueOf());
                        }
                    }
                    
                    ticks.push(moment.utc(max).valueOf());
                    ticks.push(moment.utc(maxTick).valueOf());

                    setTicks(ticks);
                }
            })
        }

    }, [props.searchProps])

    // 온도 차트
    const chart1Config = {
        id:'chart1',
        chart:chart1,
        xData: "create_dtm",
        referenceLineY:{
            y: '0',
            stroke: "#827E7E",
            fill: "#827E7E",
            label:"0°C"
        },
        YAxis: {
            type: "number",
            domain: [-20, 50],
            allowDataOverflow:true,
            allowDecimals: true,
            tickCount: 10,
        },
        XAxis: {
            type: chart1 === "bar" ? "category" : "number",
            tickCount: 1,
            interval: 0,
            ...(ticks && {domain:[ticks[0],ticks[ticks.length-1]] ,ticks:ticks})
        },
        lineConfig:[
            {
                lineType: chart1,
                type: "monotone",
                dataKey: "kmaTemp",
                stroke: "#5d97dc",
                fill: "#5d97dc",
                name: "온도",
            },

        ],
        data:{},
    }

    // 습도 차트
    const chart2Config = {
        id:'chart',
        chart:chart2,
        xData: "create_dtm",
        YAxis: {
            type: "number",
            domain: [0, 100],
            allowDataOverflow:true,
            allowDecimals: true,
            tickCount: 10
        },
        XAxis: {
            type: chart2 === "bar" ? "category" : "number",
            tickCount: 1,
            interval: 0,
            ...(ticks && {domain:[ticks[0],ticks[ticks.length-1]] ,ticks:ticks})
        },
        lineConfig:[
            {
                lineType: chart2,
                type: "monotone",
                dataKey: "kmaHumidity",
                stroke: "orange",
                fill: "orange",
                name: "습도"
            },

        ],
        data:{}
    }

    // 풍속 차트
    const chart3Config = {
        id:'chart3',
        chart:chart3,
        xData: "create_dtm",
        YAxis: {
            type: "number",
            domain: [0, 30],
            allowDataOverflow:true,
            allowDecimals: true,
            tickCount: 10
        },
        XAxis: {
            type: chart3 === "bar" ? "category" : "number",
            tickCount: 1,
            interval: 0,
            ...(ticks && {domain:[ticks[0],ticks[ticks.length-1]] ,ticks:ticks})
        },
        lineConfig:[
            {
                lineType: chart3,
                type: "monotone",
                dataKey: "kmaWindSpeed",
                stroke: "orange",
                fill: "orange",
                name: "풍속"
            },

        ],
        data:{}
    }

    // 수집데이터 테이블
    const [tableConfig, setTableConfig] = useState([
        {headerName: '일자', field: 'insert_dt', flex: 1},
        {headerName: '시간', field: 'insert_time', flex: 1},
        {headerName: '상태', field: 'status', flex: 1, cellRenderer: (props) => gridBadgeRender(props.value, getStatusGroupColor(props.data.statusGroup),"white")}
    ]);

    const gridConfig = {
        columnDefs: tableConfig,
        pagination: false,
        suppressRowHoverHighlight: true,
        rowData: chartMeasurement.map((ele) => {

            return {
                ...ele,
                insert_dt:moment.utc(ele.create_dtm).format("YYYY-MM-DD"),
                insert_time:moment.utc(ele.create_dtm).format("HH:mm"),
            }
        }),
    }


    return (
        <Flex fullWidth flexDirection={isMobile ? "column" : "row"} gap={12} style={{ flex: 1, minHeight: 0 }}>
            { props.customBtnWrap && ( props.customBtnWrap ) }
            <Flex flexDirection="column" gap={10} style={{flex: 1, minHeight: 0, minWidth: 0}}>
                <Flex flexDirection={isMobile ? "column" : "row"} gap={12} style={{flex: 1}}>
                    <Chart config={chart1Config} data={chartMeasurement} title="기온 (°C)" setChart={setChart1}/>
                    <Chart config={chart3Config} data={chartMeasurement} title="풍속 (m/s)" setChart={setChart3}/> 
                </Flex>
                <Flex flexDirection={isMobile ? "column" : "row"} gap={12}>
                    <Chart config={chart2Config} data={chartMeasurement} title="습도 (%)" setChart={setChart2}/>
                    <div style={{flex: 1, padding:"10px"}}></div>
                </Flex>
            </Flex>

            <Card style={{ width: isMobile ? '100%' : '400px', flexShrink: 0, display: 'flex', minHeight: 0, backgroundColor: "#F7F8FA", flex: isMobile ? "0 0 auto" : "0 0 30%" }}>
                <Padding paddingX={10} paddingY={15} style={{ flex: 1, display: "flex", flexDirection: "column", width: "100%", height: isMobile ? "400px" : "auto", minHeight: 0 }}>
                    <Text weight={"bold"}>예특보</Text>
                    <Spacer direction='vertical' size={15} />
                    {
                        chartMeasurement && chartMeasurement.length > 0 ? (
                            <AgGridReact
                                {...gridConfig}
                                style={{fontSize:'1.1em'}}
                            />
                        ) : (
                            <Card fullWidth height={"100%"}>
                                <Flex alignItems="center" justifyContent="center" height="100%" gap={10} flexDirection="column"
                                    style={{
                                        flex: 1,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: "#88888a",
                                        minHeight: "220px"
                                    }}
                                    >
                                    <img src={ImgFolder} alt=""/>
                                    <Text size={16} weight={"semibold"}>데이터가 없습니다.</Text>
                                </Flex>
                            </Card>
                        )
                    }
                </Padding>
            </Card>
        </Flex>
    );
}

export default DataChartNew;
